
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(55342|97830)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
